<template>
  <PopupModalWithoutTransition
    :open="open"
    class="sm:max-w-3xl sm:w-full h-[540px] z-50"
    has-close-button
  >
    <template #header>
      <div class="flex items-stretch mb-4">
        <div class="flex flex-col justify-start text-left">
          <span class="text-display2 italic">Nutzerverhalten</span>
        </div>
      </div>
    </template>
    <template #body>
      <div>
        <h2>Nutzerverhalten</h2>
      </div>
      <div class="flex flex-col mt-8 text-left">Lorem Ipsum</div>
    </template>
  </PopupModalWithoutTransition>
</template>

<script setup lang="ts">
import PopupModalWithoutTransition from "../layout/PopupModalWithoutTransition.vue";

defineProps({
  open: Boolean,
});
</script>
